<!-- <span
  [ngClass]="{
    'active': isActive(),
    'inactive': isInactive()
  }"
>
  {{ status }}
</span> -->
<div
  class="badge-group py-2"
  [ngClass]="{
    delivered: isComplete(),
    in_transit: inTransit(),
    shipped: isShipped(),
    ' ': isShipped(),
    null: isShipped(),
    due: isDue()
  }"
>
  <span class="dot"></span><span>&nbsp;{{ statusName }}</span>
</div>
